import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

export async function getAccessLogsAPI(params) {
  const { offset, limit = 10, category, user, credentials, zone, from, to } = typeof params === 'object' ? params : { offset: params };
  const formatMultiValue = (value) => (Array.isArray(value) ? value.join(',') : value);
  const query = new URLSearchParams({
    offset,
    limit,
    ...(category && { category: formatMultiValue(category) }),
    ...(user && { userId: formatMultiValue(user) }),
    ...(credentials && { credentials: formatMultiValue(credentials) }),
    ...(zone && { zoneId: formatMultiValue(zone) }),
    ...(from && { from }),
    ...(to && { to }),
  }).toString();

  const url = `${AWS_API_URL}/2n/access-logs?${query}`;

  return getRequest(url, await authorize());
}
